import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import qs from 'qs'

import { Path, PathGenerator, ExternalPath } from "../../constants/path";
import { settings } from "../../assets/settings";
import { Link, Button } from "../util/Clickable";
import { Image } from "../util/Image";
import Plan from "./Plan";

import { getPlans } from "../../actions/facility";

import ReactGA from 'react-ga';
ReactGA.initialize('UA-142451086-2');
ReactGA.pageview(window.location.pathname + window.location.search);


declare var UIkit;

class Facility extends Component {

  render = () => {
    const facility = this.props.facility;
    return (
      <div className="uk-facility-card uk-box-shadow-small uk-margin">
        <div className="uk-facility-title">
          <h1 className="uk-margin-remove uk-h2">
            { facility.name }
          </h1>
        </div>
        <div className="uk-padding-small">
          <div data-uk-grid className="uk-grid-small">
            <div className="uk-width-expand">
              <dl className="uk-description-list">
                <dt>所在地</dt>
                <dd>
                  <span className="uk-margin-small-right">{ facility.address }</span>
                  <a target="_blank" href={"https://www.google.co.jp/maps/place/"+facility.address}>Googleマップで見る</a>
                </dd>
                <dt>アクセス</dt>
                <dd>
                  { facility.access }
                </dd>
                <dt>TEL</dt>
                <dd>
                  <a href={ "tel:"+facility.tel }>
                    { facility.tel }
                  </a>
                </dd>
                <dt>公式サイト</dt>
                <dd>
                  <ReactGA.OutboundLink eventLabel={"詳細 > " + facility.name + " 公式  > " + facility.home_url} to={facility.home_url} target="_blank">
                    {facility.home_url}
                  </ReactGA.OutboundLink>
                </dd>
              </dl>
            </div>
            <div className="uk-width-auto">
              <div className="uk-facility-image uk-image-wrapper">
                <Image src={facility.image_url_m} alt={ facility.name } />
              </div>
            </div>
            <div className="uk-width-1-1">
              <dl className="uk-description-list">
                <dt>詳細</dt>
                <dd>
                  { facility.description }
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
      getPlans: (...data) => dispatch( getPlans(...data) )
    }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Facility))
